import React, { useState, useEffect, useRef, createContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Col, Button, Label, Form, FormGroup } from 'reactstrap'
import { Icon } from 'semantic-ui-react'
import RequestServiceAttachment from '../RequestServiceComponents/RequestServiceAttachment'
//import Attachments from '../RequestServiceComponents/Attachments'
import Preview from '../RequestServiceComponents/RequestServicePreview'
import { TwitterPicker } from 'react-color'
import {
  SaveServiceRequestDetails,
  GetServiceRequestSetupDetails
} from '../../../../action/workorderAction'
import { setAmplitudeEvent } from 'amplitude/amplitude'

export const PreviewContext = createContext();
export default function ServiceRequestSetUp ({ Premise }) {
  /*state declaration*/
  const [companyNameError, setCompanyNameError] = useState(false)
  const [companyNameErrorMsg, setCompanyNameErrorMsg] = useState('')
  const [FilesLists, setFilesLists] = useState([])
  const [bgColor, setBackgroundColor] = useState('#22537A')
  const [IsSaveClicked, setIsSaveClicked] = useState(false)
  const [chkServiceRequest, setChkServiceRequest] = useState(false)
  const [chkServiceRequestChecked, setChkServiceRequestChecked] = useState(
    false
  )
  const [controlsEnabled, setControlsEnabled] = useState(false)
  const [isDataLoadedfromDB, setIsDataLoadedfromDB] = useState(false)
  const [isChkDisable, setIsChkDisable] = useState(false)
  const [isBtnVisible, setIsBtnVisible] = useState(true)
  const [imageURL, setImageURL] = useState('')
  const [isViewModeCtlsVisible, setIsViewModeCtlsVisible] = useState(false)
  const [companyName, setCompanyName] = useState(null)
  const [dbValues, setDBValues] = useState([])
  const [editSaveButton, setEditSaveButton] = useState(false)
  const [file, setFile] = useState(null)

  /*ref declaration*/
  const companyNameRef = useRef('')
  const childAttachmentClearFunc = useRef(null)
  const childCompRef = useRef()

  /*map state to props*/
  const dataFromDB = useSelector(
    state => state.WorkorderRootReducer.ServiceRequestSetUpDetails
  )

  const labelDetails = useSelector(
    state =>
      state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference
  )

  /*map dispatch to props*/
  const dispatch = useDispatch()

  useEffect(() => {
    /*Scroll to top of the page*/
    setBackgroundColor('#22537A')
    var scrollPageTop = Premise
      ? document.getElementsByClassName('Ensemble_Content_FullPage')
      : document.getElementsByClassName('Ensemble_Content')
    if (scrollPageTop[0] !== undefined) {
      Premise
        ? scrollPageTop[0].scrollIntoView()
        : (scrollPageTop[0].scrollTop = 0)
    }

    LoadData()
  }, [])

  useEffect(() => {
    if (dataFromDB != null && dataFromDB.length > 0) {
      setDBValues(dataFromDB)
      if (childCompRef.current != null) {
        childCompRef.current.ClearError()
      }
      if (dataFromDB[0].isServiceRequestEnabled) {
        if (
          dataFromDB[0].customLogo !== null &&
          dataFromDB[0].customLogo !== ''
        ) {
          setImageURL('data:image/png;base64,' + dataFromDB[0].customLogo)
        } else {
          setImageURL('')
        }

        setCompanyName(dataFromDB[0].companyName)
        setBackgroundColor(dataFromDB[0].colorCode)
        setIsDataLoadedfromDB(true)

        setControlsEnabled(false)
        setChkServiceRequestChecked(true)
        setIsChkDisable(true)
        setIsBtnVisible(false)
        setIsViewModeCtlsVisible(true)
        setEditSaveButton(false)
      } else {
        setIsDataLoadedfromDB(false)
        if (companyNameRef.current != null) {
          companyNameRef.current.value = ''
        }
        if (childCompRef.current != null) {
          childCompRef.current.LoadFilesList([])
        }

        setBackgroundColor('#22537A')

        setControlsEnabled(false)
        setChkServiceRequestChecked(false)
        setIsChkDisable(false)
        setIsBtnVisible(true)
        // setIsViewModeCtlsVisible(false)
        // setEditSaveButton(true)
      }
    } else {
      setIsDataLoadedfromDB(false)
    }
  }, [dataFromDB])

  useEffect(() => {
    if (IsSaveClicked) {
      SubmitDetails()
    }
  }, [IsSaveClicked])

  useEffect(() => {
    if (!isViewModeCtlsVisible) {
      FilesfromDB()
    }
  }, [isViewModeCtlsVisible])

  useEffect(() => {
    if (chkServiceRequest) {
      setControlsEnabled(true)
    } else {
      setControlsEnabled(false)
    }
  }, [chkServiceRequest])

  useEffect(() => {
    if (isDataLoadedfromDB) {
      setControlsEnabled(false)
      setChkServiceRequestChecked(true)
      setIsChkDisable(true)
      setIsBtnVisible(false)
      setIsViewModeCtlsVisible(true)
      setEditSaveButton(false)
      // To Preview Logo
      if (imageURL !== '') {
        fetch(imageURL)
          .then(res => res.blob())
          .then(blob => {
            const file = new File([blob], dbValues[0].logoName, {
              type: 'image/png'
            })
            setFile(file)
          })
      }
    }
  }, [isDataLoadedfromDB])

  const SubmitDetails = () => {
    setIsSaveClicked(false)
    if (!companyNameError) {
      setEditSaveButton(false)
      const setUpData = new FormData()
      if (
        FilesLists !== undefined &&
        FilesLists !== null &&
        FilesLists.length > 0
      ) {
        FilesLists.forEach(el => {
          setUpData.append('File', el)
        })
      }
      setUpData.append('CustomerName', companyNameRef.current.value.trim())
      setUpData.append('isRequestEnabled', chkServiceRequestChecked)
      setUpData.append('ColorCode', bgColor)
      //Amplitude
      var amplitudeObj = {};
      if(isBtnVisible){
        amplitudeObj['Save Type'] = 'New'
        amplitudeObj['Enable'] = 'Enabled'
        amplitudeObj['Company Name'] = (companyNameRef.current.value.trim() !== "") ? companyNameRef.current.value.trim() : 'Null'
        amplitudeObj['Background Color'] = bgColor
        amplitudeObj['Custom Logo'] = (FilesLists !== undefined && FilesLists !== null && FilesLists.length > 0) ? true : false
      }else{
        amplitudeObj['Save Type'] = 'Edit'
        if(controlsEnabled){
          amplitudeObj['Enable'] = 'Enabled'
          let CompanyName = dataFromDB[0].companyName !== null ? dataFromDB[0].companyName : ""
          if(companyNameRef.current.value.trim() !== CompanyName){
            if(companyNameRef.current.value.trim() !== "")
              amplitudeObj['Company Name'] = companyNameRef.current.value.trim()
            else
              amplitudeObj['Company Name'] = 'Null'
          }
          if(bgColor !== dataFromDB[0].colorCode)
            amplitudeObj['Background Color'] = bgColor
          if(FilesLists !== undefined && FilesLists !== null && FilesLists.length > 0){
            if(FilesLists[0].name !== dataFromDB[0].logoName && FilesLists[0].size !== dataFromDB[0].fileSize){
              amplitudeObj['Custom Logo'] = true
            }
          }else{
            if(dataFromDB[0].logoName !== null){
              amplitudeObj['Custom Logo'] = false
            }
          }
        }else{
          amplitudeObj['Enable'] = 'Disabled'
        }
      }  
      setAmplitudeEvent("Work Order Service Request Page",amplitudeObj)
      dispatch(SaveServiceRequestDetails(setUpData))
    }
  }

  const ClearAllError = () => {
    setCompanyNameError(false)
    setCompanyNameErrorMsg('')
  }

  const OnEditClick = () => {
    setEditSaveButton(true)
    setControlsEnabled(true)
    setIsChkDisable(false)
    setIsViewModeCtlsVisible(false)
  }

  const OnSaveClick = () => {
    setIsSaveClicked(true)
    ClearAllError()

    var companyName = companyNameRef.current.value.trim()
    var RegexRestrictSpecialCharacter =/^[a-zA-Z0-9_\-.,&()$:! ]*$/.test(companyName);
  setFile(FilesLists[0])
    if(!chkServiceRequestChecked){
      setCompanyName(null)
      setBackgroundColor('#22537A')
    }else{
      if (companyName !== '' && !RegexRestrictSpecialCharacter) {
          setCompanyNameError(true)
          setCompanyNameErrorMsg(
            labelDetails[
              'WorkOrderServiceRequestSetup.CompanyNameInvalidError.Text'
          ])
      } 
    } 
  }

  const AddUploadedFiles = FilesList => {
    setFilesLists(FilesList)
    setFile(FilesList[0])
  }

  const handleChangeComplete = color => {
    setBackgroundColor(color.hex)
  }

  const onServiceRequestFormSetUpChange = checked => {
    setChkServiceRequest(checked)
    setChkServiceRequestChecked(checked)
    if (checked) {
      setControlsEnabled(true)
    } else {
      setControlsEnabled(false)
    }
  }

  const LoadData = () => {
    dispatch(GetServiceRequestSetupDetails())
  }

  const FilesfromDB = () => {
    if (
      companyNameRef.current != null &&
      dbValues != null &&
      dbValues.length > 0 &&
      dbValues[0].isServiceRequestEnabled
    ) {
      companyNameRef.current.value = dbValues[0].companyName
      if (imageURL !== '') {
        fetch(imageURL)
          .then(res => res.blob())
          .then(blob => {
            const file = new File([blob], dbValues[0].logoName, {
              type: 'image/png'
            })
            const loaddata = [file]
            if (childCompRef.current != null) {
              childCompRef.current.LoadFilesList(loaddata)
              setFile(loaddata[0])
            }
          })
      }
    }
  }

  return (
    <div className={Premise ? 'main_container' : 'cloud_main_container'}>
      <div className='border_container'>
        <br></br>
        <div className='row row_padding'>
          <div className='col-md-5'>
            <Form>
              <FormGroup row>
                <Col sm={{ size: 12 }} style={{ 'margin-left': '25px' }}>
                  <label
                    style={{ fontSize: '20px', fontFamily: 'Arial',width:'300px' }}
                    className='ServiceRequest_Header_lbl'
                  >
                    {labelDetails['WorkOrderServiceRequestSetup.Label.Text']}
                  </label>
                  <Button id="ServiceReqEditbtn"
                    className='ServiceRequest_btn ServiceRequest_enable_btn'
                    style={
                      { 'margin-right': '55px' } &&
                      (isDataLoadedfromDB && !editSaveButton
                        ? { display: 'block' }
                        : { display: 'none' })
                    }
                    onClick={() => OnEditClick()}
                  >
                    {labelDetails['WorkOrderServiceRequestSetup.Edit.Text']}
                  </Button>
                  <Button id="ServiceReqSavebtn"
                    className='ServiceRequest_btn ServiceRequest_enable_btn'
                    style={
                      { 'margin-right': '55px' } &&
                      (editSaveButton && isDataLoadedfromDB
                        ? { display: 'block' }
                        : { display: 'none' })
                    }
                    onClick={() => OnSaveClick()}
                  >
                    {labelDetails['WorkOrderServiceRequestSetup.Save.Text']}
                  </Button>
                </Col>
              </FormGroup>
              
              <FormGroup row style={{ marginBottom: '0.5rem'}}>
                <Col sm={{ size: 12 }} style={{ 'margin-left': '25px' }}>
                  <label
                   className='ServiceRequest_Content_lbl'
                   style={{
                    color: 'rgb(30, 30, 30)',
                    letterSpacing: '0px',
                    lineHeight: '22px',
                   }}>
                     {"By activating the Work Order Service Request, you agree to the "}
                     <a href="https://www.tranetechnologies.com/en/index/terms-of-use.html" 
                      target={"_blank"} 
                      rel="noopener noreferrer">
                      {"terms and conditions "}
                      </a>
                     {"of our services."}
                  </label>
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={{ size: 12 }} style={{ 'margin-left': '25px' }}>
                  <input
                    type='checkbox'
                    className='serviceRequestCheckBox'
                    id='enableChk'
                    disabled={isChkDisable}
                    checked={chkServiceRequestChecked}
                    onClick={e =>
                      onServiceRequestFormSetUpChange(e.target.checked)
                    }
                  />
                  <Label
                    for='enableChk'
                    className='form_sub_title'
                    style={{ margin: '5px', fontSize: '16px', fontWeight: 100, fontFamily: 'Arial' }}
                  >
                    {labelDetails['WorkOrderServiceRequestSetup.Checkbox.Text']}
                  </Label>
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={{ size: 6 }} style={{ 'margin-left': '25px' }}>
                  <label
                    style={{ fontSize: '14px', fontFamily: 'Arial' }}
                    className='ServiceRequest_Header_lbl'
                  >
                    {labelDetails['WorkOrderServiceRequestSetup.Options.Text']}
                  </label>
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={{ size: 8 }} style={{ 'margin-left': '25px' }}>
                  <label
                    style={{ fontSize: '14px', fontFamily: 'Arial' }}
                    className={'ServiceRequest_Content_lbl'}
                  >
                    {
                      labelDetails[
                        'WorkOrderServiceRequestSetup.CompanyName.Text'
                      ]
                    }
                  </label>
                  <br />
                  {isViewModeCtlsVisible ? (
                    <label
                      style={{
                        fontSize: '16px',
                        fontFamily: 'Arial',
                        lineHeight: '15px',
                        width: '231px',
                        letterSpacing: '0.32px',
                        color: 'rgb(38,38,38)'
                      }}
                      className={'ServiceRequest_Content_lbl'}
                    >
                      {companyName !== null ? companyName : '--'}
                    </label>
                  ) : (
                    <input
                      type='text'
                      disabled={!controlsEnabled}
                      maxLength='50'
                      style={{ width: '60%', height: '36px', fontFamily: 'Arial' }}
                      className={
                        companyNameError
                          ? 'ServiceRequest_Content_txtbox RequesErrorMsgHighlight'
                          : 'ServiceRequest_Content_txtbox'
                      }
                      onChange={(event) => setCompanyName(event.target.value) } 
                      ref={companyNameRef}
                      id="ServiceReqCompanyNameTxt"
                    />
                  )}
                  <br />
                  <span hidden={companyNameError ? false : true}>
                    <Icon
                      name='exclamation triangle'
                      style={{ color: '#D52B1E' }}
                    />
                    <label
                      style={{
                        color: '#D52B1E',
                        fontSize: '12px',
                        fontFamily: 'Arial'
                      }}
                    >
                      {companyNameErrorMsg}
                    </label>
                  </span>
                </Col>
              </FormGroup>
              <br/>

              <FormGroup row>
                <Col sm={{ size: 6 }} style={{ 'margin-left': '25px' }}>
                <label
                  style={{ fontSize: '14px', fontFamily: 'Arial' }}
                  className='ServiceRequest_Header_lbl'
                >
                  {
                    labelDetails[
                      'WorkOrderServiceRequestSetup.BackGround.Text'
                    ]
                  }
                </label>
                <br/>
                  <div style={!controlsEnabled ? { pointerEvents: 'none' } : {}}>
                    <TwitterPicker
                      styles={{height:'10px'}}
                      triangle='hide'
                      width='190px'
                      color={bgColor}
                      onChangeComplete={handleChangeComplete}
                      colors={[
                        '#22537a',
                        '#5856d6',
                        '#53b2d4',
                        '#42cdc9',
                        '#66bb6a',
                        '#b269c8',
                        '#fb19ad',
                        '#f85f57',
                        '#ffa726',
                        '#f8bd00',
                        '#4c4c4c',
                        '#7d7d7d'
                      ]}
                      id="ServiceReqColorPicker"
                    />
                  </div>
                </Col>
              </FormGroup>
              <br/>

              <FormGroup row>
                <Col sm={{ size: 12 }} style={{ 'margin-left': '25px' }}>
                <label
                    style={{ fontSize: '14px', fontFamily: 'Arial' }}
                    className='ServiceRequest_Header_lbl'
                  >
                    {
                      labelDetails[
                        'WorkOrderServiceRequestSetup.CustomLogo.Text'
                      ]
                    }
                  </label>
                  <br/>
                  {isViewModeCtlsVisible && imageURL !== '' ? (
                    <img
                      style={{ border: '1px solid black', "max-height": "120px",
                      "min-height": "44px", "max-width": "190px", "min-width": "44px" }}
                      src={imageURL}
                      alt=''
                    ></img>
                  ) : (
                    <>
                      <label className='ServiceRequest_Content_lbl'>
                        {
                          labelDetails[
                            'WorkOrderServiceRequestSetup.Attachments.Text'
                          ]
                        }
                      </label>
                      <br />
                      <RequestServiceAttachment
                        UploadSRFile={AddUploadedFiles}
                        childAttachmentClearFunc={childAttachmentClearFunc}
                        ref={childCompRef}
                        isDisabled={!controlsEnabled}
                        hintText={
                          labelDetails['WorkOrderServiceRequestSetup.Hint.Text']
                        }
                        fileSize={
                          labelDetails[
                            'WorkOrderServiceRequestSetup.FileSize.Text'
                          ]
                        } //1 MB
                        fileTypes={[
                          labelDetails[
                            'WorkOrderServiceRequestSetup.FileTypes.Text'
                          ]
                        ]}
                      />
                    </>
                  )}
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={{ size: 12 }} style={{ 'margin-left': '25px' }}>
                  <Button id="ServiceReqFinalSavebtn"
                    disabled={!controlsEnabled}
                    className='ServiceRequest_btn ServiceRequest_enable_btn'
                    style={
                      { 'margin-right': '55px' } && !isBtnVisible
                        ? { display: 'none' }
                        : { display: 'block' } && !controlsEnabled
                        ? { pointerEvents: 'none' }
                        : {}
                    }
                    onClick={() => OnSaveClick()}
                  >
                    {labelDetails['WorkOrderServiceRequestSetup.Save.Text']}
                  </Button>
                </Col>
              </FormGroup>

              <FormGroup column style={{width : '50%'}}>
              </FormGroup>
            </Form>
          </div>
       

          {/* preview section */}
          <div className='col-md-5' style={{"paddingTop" : "5.5%"}}>
                           
          <PreviewContext.Provider value={{ bgColor: bgColor, companyName: companyName, file: file }}> 
                     <Preview ></Preview>
                   </PreviewContext.Provider>
          </div>
        </div>
      </div>
    </div>
  )
}
